import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import MultiLayerFilter from '../../Common/MultiLayerFilter';
import { formatTeamOptions } from '../../static/filterUtil';

const Team = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [selectedMultilevelData, setSelectedMultiLevelData] = useState([]);
	const multiLevelFilterStore = useSelector((store) => store.multiLevelFIlterStore);
	const currentSelectedFilterLevel = multiLevelFilterStore?.currentSelectedFilterLevel;

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setSelectedMultiLevelData(multiLevelFilterStore?.multiLevelFilters);
	}, [multiLevelFilterStore]);

	useEffect(() => {
		onFetchData();
	}, [selectedField, filterPageName]);

	const onFetchData = async () => {
		let options =
			formatTeamOptions({
				tpCompletedByList: dependentFilterList?.tpCompletedByList || [],
				addedToFavByList: dependentFilterList?.addedToFavByList || [],
				createdByList: dependentFilterList?.createdByList || [],
				designedByList: dependentFilterList?.designedByList || []
			}) || [];

		if (
			filterPageName === 'COLLECTION_DETAILS' ||
			filterPageName === 'PRODUCT_LIST' ||
			filterPageName === 'ARTWORK_LIST'
		) {
			options = options.filter((item) => item.id !== 'ADDED_TO_FAVOURITE_BY');
		}
		if (filterPageName === 'ARTWORK_LIST') {
			options = options.filter((item) => item.id !== 'TP_COMPLETED_BY');
		}

		setAllData(options);
		setData(options);
	};

	return (
		<MultiLayerFilter
			filterOptions={data}
			selectedField={selectedField}
			selectedMultilevelData={selectedMultilevelData}
			allOptions={allData}
			setFilterOptions={setData}
			currentSelectedFilterLevel={currentSelectedFilterLevel}
			type="TEAM"
			isReplaceHyphens={false}
		/>
	);
};

export default Team;
